import { makeApiError } from '@packages/shared-ui/errors';
import axios, { type AxiosResponse } from 'axios';
import { FEATURE_FLAGS_URL } from '@/constants/baseUrls';

export type FeatureFlagResponse = Record<
  string,
  string | string[] | Record<string, number>
>;

const getFeatureFlagsUrl = (): string => {
  if (typeof window === 'undefined') return FEATURE_FLAGS_URL;
  const { hostname } = window.location;
  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    return '/api/feature-flags';
  }
  return FEATURE_FLAGS_URL;
};

export const getFeatureFlags = async (): Promise<
  AxiosResponse<FeatureFlagResponse>
> => {
  try {
    return await axios.get<FeatureFlagResponse>(getFeatureFlagsUrl());
  } catch (err) {
    console.error(err);
    throw makeApiError(err);
  }
};
